export const EMAIL_FONTS = [
  'Arial, Helvetica, sans-serif',
  'Georgia, serif',
  "'Times New Roman', Times, serif",
  "'Trebuchet MS', Helvetica, sans-serif",
  'Verdana, Geneva, sans-serif',
  "'Courier New', Courier, monospace",
  'Tahoma, Geneva, sans-serif',
  'Helvetica, Arial, sans-serif',
] as const;
